export default __webpack_public_path__ + "static/media/sweets.fe02948d.gif";